import { API_BASE_URL, apiGet } from './api-utils';
import { IResult } from '../models/result-models';
import { IProductAvailabilityItem } from '../../../../../Application/TypewriterModels/IProductAvailabilityItem';

const productAvailabilityPrefix = '/v1/productAvailability/';
const productAvailabilityUrl =
    API_BASE_URL + productAvailabilityPrefix + 'getProducts';
const lastUpdatedUrl =
    API_BASE_URL + productAvailabilityPrefix + 'getLastUpdate';

export const getProdudctAvailabilityData = async (): Promise<
    IResult<IProductAvailabilityItem[]>
> => {
    const result = await apiGet<IProductAvailabilityItem[]>(
        productAvailabilityUrl
    );

    return result;
};

export const getLastUpdatedData = async (): Promise<IResult<string>> => {
    const result = await apiGet<string>(lastUpdatedUrl);

    return result;
};
